import React from "react";
import { useCompanion } from "./CompanionContext";
import PresenceVessel from "./PresenceVessel";
import TotoOccupant from "./renderers/TotoOccupant";

/**
 * CompanionPresence — the durable shared presentation boundary.
 *
 * Renders SONMI's universal PresenceVessel. If the active CompanionProfile
 * names an occupant, it is placed inside the vessel; otherwise the vessel
 * simply exists (which is Morrow's default behavior — an empty vessel is
 * itself a legitimate presence).
 *
 * Shared code renders:
 *   <CompanionPresence size={56} />
 *
 * — never the vessel directly, never an occupant directly.
 */
const OCCUPANTS = {
  "toto-westie": TotoOccupant,
  // Future companions register here. Passing `null` (or an unknown key)
  // leaves the vessel empty — that is a valid CompanionProfile choice.
};

export default function CompanionPresence({
  size = 56,
  presence = "present",
  ambient,
  profile: overrideProfile = null,
}) {
  const activeProfile = useCompanion();
  const profile = overrideProfile || activeProfile;
  const Occupant = profile.occupantKey ? OCCUPANTS[profile.occupantKey] : null;

  return (
    <span data-testid="companion-presence" data-companion={profile.id}>
      <PresenceVessel size={size} presence={presence} ambient={ambient}>
        {Occupant ? <Occupant /> : null}
      </PresenceVessel>
    </span>
  );
}
